import React, { Component } from 'react'
import InputChat from './InputChat'
import ChatCard from './ChatCard'
import './Chat.css'

export default class Chat extends Component {
  render() {
    return (
      <div className='chat' >

        <InputChat {...this.props} />
        <div style={{ maxHeight: 700, overflowY: 'scroll' }} >
          <ChatCard {...this.props} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Chat/Chat.js